import { __extends } from "tslib";
import { GetEmailTemplateRequest, GetEmailTemplateResponse } from "../models/models_0";
import { deserializeAws_restJson1GetEmailTemplateCommand, serializeAws_restJson1GetEmailTemplateCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetEmailTemplateCommand = /** @class */ (function (_super) {
    __extends(GetEmailTemplateCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetEmailTemplateCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetEmailTemplateCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PinpointClient";
        var commandName = "GetEmailTemplateCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: GetEmailTemplateRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetEmailTemplateResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetEmailTemplateCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1GetEmailTemplateCommand(input, context);
    };
    GetEmailTemplateCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1GetEmailTemplateCommand(output, context);
    };
    return GetEmailTemplateCommand;
}($Command));
export { GetEmailTemplateCommand };
//# sourceMappingURL=GetEmailTemplateCommand.js.map